export const ON_VISIT_REPETITION = 500;
